<template>
  <div class='rightside-menu' v-bind:class='{ open: isOpenMobileMenu }'>
    <div class='operations'>
      <div class='buttons'>
        <lang-toggle class='lang-toggle-inline' variant='light' />
        <a @click.prevent.stop='$emit("resetcamera")' class='button'>{{ $t('視点リセット') }}</a>
        <a @click.prevent.stop='$emit("help")' class='button'>{{ $t('ヘルプ') }}</a>
        <!-- <a
          v-if='ar && userAgent === "iOS"'
          @click.prevent.stop='$emit("iosar")'
          class='button'
        >
          AR - iOS
        </a>
        <a
          v-else-if='ar && userAgent === "Android"'
          @click.prevent.stop='$emit("androidar")'
          class='button'
        >
          AR - Android
        </a>
        <a
          v-else-if="ar"
          @click.prevent.stop="$emit('qrcode')"
          class="button"
        >
          ARで見る
        </a> -->
      </div>
      <template v-if='mode !== Modes.TOOLPATH && mode !== Modes.TOOLPATH_ONLY'>
        <select
          v-if='materials.length > 0'
          :value='material'
          @change='$emit("changematerial", $event)'
        >
          <option v-for='mat in materials' v-bind:value='mat' v-text='mat' :key="mat"></option>
        </select>
        <template v-if="!isProd">
          <!-- ミルサイズ -->
          <select
            v-if="millSizes.length > 0"
            :value="millSize"
            @change="$emit('changeMillSize', $event)"
            style="margin-top: 10px;"
          >
            <option v-for="ms in millSizes" v-bind:value="ms" :key="ms">{{ ms }}mm</option>
          </select>
          <!-- 機械タイプ -->
          <select
            :value="machineType"
            @change="$emit('changeMachineType', $event)"
            style="margin-top: 10px"
          >
            <option value="Alpha">Shopbot Alpha</option>
            <option value="DesktopMAX">Shopbot Desktop MAX</option>
          </select>
        </template>
        <div class='bounding-box'>
          <span>{{ $t('サイズ表示') }}</span>
          <div class='toggle'>
            <div class='item'>
              <input
                id='bounding_box'
                type='checkbox'
                v-model='boundingBox.visible'
                @change='$emit("syncboundingbox")'
              />
              <label for='bounding_box'></label>
            </div>
          </div>
        </div>
      </template>
    </div>
    <template v-if='mode !== Modes.TOOLPATH && mode !== Modes.TOOLPATH_ONLY'>
      <div class='controller' v-show="UIs.length > 0">
        <ul>
          <li v-for='(o, i) in UIs' :key="'ui-' + i">
            <slider :slider='o' v-if='(o instanceof GHSliderObject)'/>
            <toggle :toggle='o' v-else-if='(o instanceof GHToggleObject)'/>
            <value-list :valueList='o' v-else-if='(o instanceof GHValueListObject)'/>
            <e-material-list :list='o' v-else-if='(o instanceof GHMaterialListObject)'/>
            <e-paint-list :list='o' v-else-if='(o instanceof GHPaintListObject)'/>
          </li>
          <li v-if="!isProd">
            <slider :slider="thicknessSlider" />
          </li>
        </ul>
      </div>
    </template>
    <template v-if='mode === Modes.TOOLPATH'>
      <div class='material-controller'>
        <ul v-if='thresholds.length > 0'>
          <li v-for='(threshold, index) in thresholds' :key="'thres-' + index">
            <div class='material-threshold'>
              <span>{{ threshold.title }}</span>
              <ul>
                <li>
                  <slider :slider='threshold.x' />
                </li>
                <li>
                  <slider :slider='threshold.y' />
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <a @click.prevent.stop='$emit("regeneratetoolpath")' class='material-button button'>Regenerate</a>
    </template>
  </div>
</template>

<script>

import UINumber from '../UINumber.vue';
import Slider from '../Slider.vue';
import Toggle from '../Toggle.vue';
import ValueList from '../ValueList.vue';
import EMaterialList from '../EMaterialList.vue';
import EPaintList from '../EPaintList.vue';
import GHSliderObject from '../../assets/javascripts/gh/GHSliderObject';
import GHToggleObject from '../../assets/javascripts/gh/GHToggleParam';
import GHValueListObject from '../../assets/javascripts/gh/GHValueListObject';
import GHMaterialListObject from '../../assets/javascripts/gh/GHMaterialListObject';
import GHPaintListObject from '../../assets/javascripts/gh/GHPaintListObject';
import Modes from '../../assets/javascripts/misc/Modes';
import LangToggle from './LangToggle.vue';

export default {

  components: {
    UINumber,
    Slider,
    Toggle,
    ValueList,
    EMaterialList,
    EPaintList,
    LangToggle
  },

  props: {
    userAgent: {
      type: String,
      default: ''
    },
    ar: {
      type: Boolean,
      default: false
    },
    isOpenMobileMenu: {
      type: Boolean,
      default: false
    },
    mode: {
      default: Modes.NONE
    },
    boundingBox: {
      type: Object,
      default: () => {
        return {
          visible: true
        };
      }
    },
    materials: {
      type: Array,
      default: () => { return []; }
    },
    material: {
      type: String,
      default: ''
    },
    millSizes: {
      type: Array,
      default: () => { return []; }
    },
    millSize: {
      type: Number,
      default: 6.35
    },
    machineType: {
      type: String,
      default: 'Alpha'
    },
    UIs: {
      type: Array,
      default: () => { return []; }
    },
    thresholds: {
      type: Array,
      default: () => { return []; }
    },
    thicknessSlider: {
      type: Object,
      default: () => { return {}; }
    }
  },

  data () {
    return {
      Modes: Modes,
      GHSliderObject: GHSliderObject,
      GHToggleObject: GHToggleObject,
      GHValueListObject: GHValueListObject,
      GHMaterialListObject: GHMaterialListObject,
      GHPaintListObject: GHPaintListObject
    };
  },

  computed: {
    isProd() {
      return this.$emarf.isProd;
    }
  },

  methods: {
    
  }
};

</script>

<style scoped>
.lang-toggle-inline {
  margin-bottom: 8px;
  display: inline-flex;
  align-self: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/RightsideMenu.vue